import { CheckCircle2 } from "lucide-react";
const categories = [{
  id: 1,
  title: "User Identity & Contact"
}, {
  id: 2,
  title: "Platform Usage & AI Interaction"
}, {
  id: 3,
  title: "Technical Logs & Device Data"
}];
const categoryItems = [{
  categoryId: 1,
  text: "Legal name, professional email, and contact phone numbers."
}, {
  categoryId: 1,
  text: "Business billing details and service delivery addresses."
}, {
  categoryId: 1,
  text: "Verification documents required for security and anti-fraud compliance."
}, {
  categoryId: 2,
  text: "Detailed history of AI operator interactions and command logs."
}, {
  categoryId: 2,
  text: "Custom automation workflows and user-defined platform settings."
}, {
  categoryId: 2,
  text: "Subscription management data and historical transaction records."
}, {
  categoryId: 3,
  text: "IP addresses, access timestamps, and browser fingerprinting."
}, {
  categoryId: 3,
  text: "Device hardware specifications and operating system versions."
}, {
  categoryId: 3,
  text: "Diagnostic log files used for performance optimization and debugging."
}];
export default function DataCollection() {
  return <section data-section-id="158290" id="data-collection-processing" className="bg-background py-16 md:py-24 radiating-pattern">
      <div className="container mx-auto px-4">
        <div className="bg-card border border-border rounded-xl p-8 md:p-12 lg:p-16 shadow-xl">
          <div className="flex flex-col">
            {categories.map((category, index) => <div key={category.id} data-index={index} className="grid grid-cols-1 md:grid-cols-12 gap-8 py-10 border-b border-border last:border-0 first:pt-0 last:pb-0">
                <div className="md:col-span-4">
                  <h2 className="font-sans text-2xl md:text-3xl font-extrabold tracking-tight text-foreground uppercase leading-tight">
                    {category.title}
                  </h2>
                </div>
                <div className="md:col-span-8">
                  <ul className="space-y-4">
                    {categoryItems.filter(item => item.categoryId === category.id).map((item, itemIndex) => <li key={itemIndex} data-index={itemIndex} className="flex items-start gap-3 text-muted-foreground font-sans text-base md:text-lg">
                          <CheckCircle2 className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                          <span>{item.text}</span>
                        </li>)}
                  </ul>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}